import * as React from "react";
import { PieChart } from "@mui/x-charts/PieChart";

interface PieChartData {
  value: number;
  label: string;
}
interface PieChartProps {
  data?: PieChartData[];
  size?: { width?: number; height?: number };
  innerRadius?: number;
  outerRadius?: number;
  paddingAngle?: number;
  colors?: string[];
  tooltipTrigger?: "none" | "item" | "axis" | undefined;
}

const defualtSize = {
  width: 400,
  height: 300,
};

export const BasicPieChart = ({
  data = [],
  size = defualtSize,
  innerRadius = 80,
  outerRadius = 140,
  paddingAngle = 0,
  colors,
  tooltipTrigger = "none",
}: PieChartProps) => {
  return (
    <PieChart
      series={[{ data, innerRadius, outerRadius, paddingAngle }]}
      {...size}
      slotProps={{
        legend: { hidden: true },
      }}
      colors={colors}
      margin={{ right: 5 }}
      tooltip={{ trigger: tooltipTrigger }}
      sx={{
        ".MuiPieArc-root": {
          strokeWidth: 0,
        },
      }}
    ></PieChart>
  );
};
